import { coreApi } from 'src/api/config';
import { get } from 'lodash';
import Notifier from 'common/helpers/Notifier';

export default async function fetchAssistanceRequests (
  personId,
  providerId,
  networkId,
  displayAssistanceRequests,
) {
  if (!displayAssistanceRequests) {
    return [];
  }

  try {
    const filters = {
      person: personId,
      originating_provider: providerId,
      network: networkId,
    };

    const assistanceRequestsQuery = await coreApi.query('assistance_requests', filters);
    const assistanceRequests = get(assistanceRequestsQuery, 'data.data', []);

    const populateCase = async (assistanceRequest) => {
      try {
        await coreApi.populateRelationship('case', 'case', assistanceRequest);
        return assistanceRequest;
      } catch (error) {
        if (error.response?.status === 403) {
          const caseId = assistanceRequest.case?.id;
          const caseSummaryResponse = await coreApi.findRecord('case_summary', caseId);

          return {
            ...assistanceRequest,
            case: caseSummaryResponse.data.data,
          };
        }

        throw error;
      }
    };

    await coreApi.populateRelationship('provider', 'provider', assistanceRequests);

    const populatedAssistanceRequests = await Promise.all(assistanceRequests.map(populateCase));
    return populatedAssistanceRequests;
  } catch (error) {
    Notifier.handleErrors(error);
    return [];
  }
}
